import { isEmpty } from "lodash-es";
import { useEffect, useRef } from "react";

import { MessageComponent } from "@/components/General/Messages/messages.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useStoreSearchContext } from "../../storeSearch.context";
import { StoreCardContainer } from "./storeCard/storeCard.container";
import { StoreCardSkeleton } from "./storeCard/storeCard.skeleton";
import "./storeSearchList.scss";

const StoreSearchListComponent = () => {
    const { stores, storesLoading } = useStoreSearchContext();

    const storeSearchListRef = useRef<HTMLUListElement>(null);

    const { t } = useGranite();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        storeSearchListRef.current?.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }, [stores]);

    if (storesLoading) {
        return (
            <ul
                ref={storeSearchListRef}
                className={
                    "store-search-list store-search-list--skeleton list-unstyled mb-0"
                }
            >
                <StoreCardSkeleton />
                <StoreCardSkeleton />
                <StoreCardSkeleton />
                <StoreCardSkeleton />
                <StoreCardSkeleton />
            </ul>
        );
    }

    if (isEmpty(stores) && !storesLoading) {
        return (
            <div className={"store-search-list"}>
                <MessageComponent
                    message={{
                        id: "store-search",
                        text: t("form.searchstore.nothingFound"),
                        status: "secondary",
                        dismissible: false,
                        activeScroll: false
                    }}
                />
            </div>
        );
    }

    return (
        <ul
            ref={storeSearchListRef}
            className={"store-search-list list-unstyled mb-0"}
        >
            {stores.map((store) => (
                <StoreCardContainer
                    key={store.properties.user_properties.storeId}
                    store={store}
                />
            ))}
        </ul>
    );
};

export { StoreSearchListComponent };
